import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios'


function Ban(){
    useEffect  (() => {
        showIp()
    
    })
    const showIp = async () =>{
        const res =  await axios.get('https://geolocation-db.com/json/')
        document.getElementById('ip').innerText = res.data.IPv4;
      }
    return(
        <div>
            <p align="right" style={{marginTop: 20}}>IP Address Banned: <span id="ip"></span></p>
            <center>
                <img src="/alert.gif" alt="Banned!!!" className="img-fluid"  width="500"/>
                <h1>You have been banned from using the application for mass spam</h1>
            </center>
        </div>
    )
}
export default Ban